module.exports = __webpack_public_path__ + "static/img/15_happy.7acb88cd.jpg";